export const DestinationStatuses = {
    PUBLISHED: 0,
    DRAFT: 1,
} as const;
